import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Totals = ({draftInvoice}) => {
  return (
    <div className="Totals">
      <div className="section">
        <div className="header">Subtotal</div>
        <div className="value">
          <Money amount={draftInvoice.priceExcludingTax} />
        </div>
      </div>
      <div className="section">
        <div className="header">Total Vat</div>
        <div className="value">
          <Money
            amount={(
              draftInvoice.priceIncludingTax - draftInvoice.priceExcludingTax
            ).toFixed(2)}
          />
        </div>
      </div>
      <div className="section">
        <div className="header">Total</div>
        <div className="value">
          <Money amount={draftInvoice.priceIncludingTax} />
        </div>
      </div>
    </div>
  );
};

export default Totals;
